var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "StandardTableListRootDiv" },
    [
      _vm._t("list-buttons"),
      _vm._v(" "),
      _vm._t("list-form"),
      _vm._v(" "),
      _vm._t("list-tabBar"),
      _vm._v(" "),
      _vm._t("list-table")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }